import { createFileRoute } from '@tanstack/react-router';
import { DeletionsTab } from '@/admin/queues/DeletionsTab';
import { ExportsTab } from '@/admin/queues/ExportsTab';
import { QueueTabs } from '@/admin/queues/QueueTabs';
import { validateQueueSearch } from '@/admin/queues/search';
import { useQueuesT } from '@/admin/queues/strings';
import { PageTitle } from '@/admin/ui/Page';

export const Route = createFileRoute('/admin/deletions/')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  validateSearch: validateQueueSearch,
  component: Deletions,
});

function Deletions() {
  const t = useQueuesT();
  const search = Route.useSearch();
  return (
    <div>
      <PageTitle>{t('admin.nav.deletions')}</PageTitle>
      <QueueTabs active={search.tab} />
      {search.tab === 'exports' ? (
        <ExportsTab search={search} />
      ) : (
        <DeletionsTab search={search} />
      )}
    </div>
  );
}
